import { createStyle } from '@gluestack-style/react';

export const FabLabel = createStyle({
  color: '$textLight50',
});
